import {useSsoStore} from "@/store/modules/sso.store";

export default {
    path: "/autorizacion",
    name: "Autorizacion",
    meta: {
        title: "Autorizacion",
    },
    children: [
        {
            path: "listado",
            name: "ListadoAutorizacion",
            component: () => import(/* webpackPrefetch: true */"@/views/modules/medical/views/components/AutorizacionMedica"),

        },
    ]
}